/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table2({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      managerId: "",
      type: "",
      email: "",
      sdt: "",
      country1: "",
      city1: "",
      district1: "",
      ward1: "",
      road1: "",
      country2: "",
      city2: "",
      district2: "",
      ward2: "",
      road2: "",
      status: "",
    },
  ]);
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      managerId: "",
      type: "",
      email: "",
      sdt: "",
      country1: "",
      city1: "",
      district1: "",
      ward1: "",
      road1: "",
      country2: "",
      city2: "",
      district2: "",
      ward2: "",
      road2: "",
      status: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        managerId: "",
        type: "",
        email: "",
        sdt: "",
        country1: "",
        city1: "",
        district1: "",
        ward1: "",
        road1: "",
        country2: "",
        city2: "",
        district2: "",
        ward2: "",
        road2: "",
        status: "",
      },
    ]);
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        managerId: "",
        type: "",
        email: "",
        sdt: "",
        country1: "",
        city1: "",
        district1: "",
        ward1: "",
        road1: "",
        country2: "",
        city2: "",
        district2: "",
        ward2: "",
        road2: "",
        status: "",
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", maxWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã quản lý trên sàn giao dịch TMĐT của nhà cung cấp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại hình
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Email liên hệ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số điện thoại liên hệ đăng ký trên Sàn
              </Td>
              <Td rowSpan={1} colSpan={5} style={{ textAlign: "center" }}>
                Thông tin địa chỉ trụ sở của tổ chức, cá nhân, hộ kinh doanh cung cấp hàng hóa dịch
                vụ thông qua Sàn
              </Td>
              <Td rowSpan={1} colSpan={5} style={{ textAlign: "center" }}>
                Thông tin địa chỉ nơi thường trú của cá nhân, hộ kinh doanh cung cấp hàng hóa dịch
                vụ thông qua Sàn
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Trạng thái
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center" }}>Tỉnh/thành phố</Td>
              <Td style={{ textAlign: "center" }}>Quận/huyện</Td>
              <Td style={{ textAlign: "center" }}>Phường/xã/thị trấn</Td>
              <Td style={{ textAlign: "center" }}>Số nhà đường, phố</Td>
              <Td style={{ textAlign: "center" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center" }}>Tỉnh/thành phố</Td>
              <Td style={{ textAlign: "center" }}>Quận/huyện</Td>
              <Td style={{ textAlign: "center" }}>Phường/xã/thị trấn</Td>
              <Td style={{ textAlign: "center" }}>Số nhà đường, phố</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[4]</Td>
              <Td style={{ textAlign: "center" }}>[5]</Td>
              <Td style={{ textAlign: "center" }}>[6]</Td>
              <Td style={{ textAlign: "center" }}>[7]</Td>
              <Td style={{ textAlign: "center" }}>[8]</Td>
              <Td style={{ textAlign: "center" }}>[9]</Td>
              <Td style={{ textAlign: "center" }}>[10]</Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
              <Td style={{ textAlign: "center" }}>[13]</Td>
              <Td style={{ textAlign: "center" }}>[14]</Td>
              <Td style={{ textAlign: "center" }}>[15]</Td>
              <Td style={{ textAlign: "center" }}>[16]</Td>
              <Td style={{ textAlign: "center" }}>[17]</Td>
              <Td style={{ textAlign: "center" }}>[18]</Td>
              <Td style={{ textAlign: "center" }}>[19]</Td>
            </tr>
            <tr>
              <Td colSpan={16} style={{ textAlign: "left", fontWeight: "bold" }}>
                I. Thông tin chung nhà cung cấp trong nước
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="managerId"
                    value={item.managerId}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "type", e.target.value)}
                  >
                    <option value="value1">Tổ chức VN</option>
                    <option value="value2">Cá nhân/hộ kinh doanh VN</option>
                    <option value="value3">Tổ chức nước ngoài</option>
                    <option value="value4">Cá nhân/hộ kinh doanh nước ngoài (không cư trú)</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="email"
                    value={item.email}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable id={item.id} name="sdt" value={item.sdt} onChange={handleChange} />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "city1", e.target.value)}
                  >
                    <option value="value1">Thành phố 1</option>
                    <option value="value2">Thành phố 2</option>
                    <option value="value3">Thành phố 3</option>
                    <option value="value4">Thành phố 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district1", e.target.value)}
                  >
                    <option value="value1">Quận 1</option>
                    <option value="value2">Quận 2</option>
                    <option value="value3">Quận 3</option>
                    <option value="value4">Quận 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "ward1", e.target.value)}
                  >
                    <option value="value1">Phường 1</option>
                    <option value="value2">Phường 2</option>
                    <option value="value3">Phường 3</option>
                    <option value="value4">Phường 4</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="road1"
                    value={item.road1}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "city2", e.target.value)}
                  >
                    <option value="value1">Thành phố 1</option>
                    <option value="value2">Thành phố 2</option>
                    <option value="value3">Thành phố 3</option>
                    <option value="value4">Thành phố 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district2", e.target.value)}
                  >
                    <option value="value1">Quận 1</option>
                    <option value="value2">Quận 2</option>
                    <option value="value3">Quận 3</option>
                    <option value="value4">Quận 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "ward2", e.target.value)}
                  >
                    <option value="value1">Phường 1</option>
                    <option value="value2">Phường 2</option>
                    <option value="value3">Phường 3</option>
                    <option value="value4">Phường 4</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="road2"
                    value={item.road2}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "status", e.target.value)}
                  >
                    <option value="value1">Thêm mới</option>
                    <option value="value2">Thay thế</option>
                  </select>
                </Td>
              </tr>
            ))}
            <SoftBox
              display="flex"
              width={150}
              marginBottom={2}
              justifyContent="flex-start"
              gap={3}
              mt={2}
            >
              <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
                Thêm dòng
              </SoftButton>
            </SoftBox>
            <tr>
              <Td colSpan={16} style={{ textAlign: "left", fontWeight: "bold" }}>
                II. Thông tin chung nhà cung cấp nước ngoài
              </Td>
            </tr>
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="managerId"
                    value={item.managerId}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "type", e.target.value)}
                  >
                    <option value="value1">Tổ chức VN</option>
                    <option value="value2">Cá nhân/hộ kinh doanh VN</option>
                    <option value="value3">Tổ chức nước ngoài</option>
                    <option value="value4">Cá nhân/hộ kinh doanh nước ngoài (không cư trú)</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="email"
                    value={item.email}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable id={item.id} name="sdt" value={item.sdt} onChange={handleChange2} />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "country1", e.target.value)}
                  >
                    <option value="value1">Quốc gia 1</option>
                    <option value="value2">Quốc gia 2</option>
                    <option value="value3">Quốc gia 3</option>
                    <option value="value4">Quốc gia 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "city1", e.target.value)}
                  >
                    <option value="value1">Thành phố 1</option>
                    <option value="value2">Thành phố 2</option>
                    <option value="value3">Thành phố 3</option>
                    <option value="value4">Thành phố 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "district1", e.target.value)}
                  >
                    <option value="value1">Quận 1</option>
                    <option value="value2">Quận 2</option>
                    <option value="value3">Quận 3</option>
                    <option value="value4">Quận 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "ward1", e.target.value)}
                  >
                    <option value="value1">Phường 1</option>
                    <option value="value2">Phường 2</option>
                    <option value="value3">Phường 3</option>
                    <option value="value4">Phường 4</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="road1"
                    value={item.road1}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "country2", e.target.value)}
                  >
                    <option value="value1">Quốc gia 1</option>
                    <option value="value2">Quốc gia 2</option>
                    <option value="value3">Quốc gia 3</option>
                    <option value="value4">Quốc gia 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "city2", e.target.value)}
                  >
                    <option value="value1">Thành phố 1</option>
                    <option value="value2">Thành phố 2</option>
                    <option value="value3">Thành phố 3</option>
                    <option value="value4">Thành phố 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "district2", e.target.value)}
                  >
                    <option value="value1">Quận 1</option>
                    <option value="value2">Quận 2</option>
                    <option value="value3">Quận 3</option>
                    <option value="value4">Quận 4</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "ward2", e.target.value)}
                  >
                    <option value="value1">Phường 1</option>
                    <option value="value2">Phường 2</option>
                    <option value="value3">Phường 3</option>
                    <option value="value4">Phường 4</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="road2"
                    value={item.road2}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "status", e.target.value)}
                  >
                    <option value="value1">Thêm mới</option>
                    <option value="value2">Thay thế</option>
                  </select>
                </Td>
              </tr>
            ))}
            <SoftBox
              display="flex"
              width={150}
              marginBottom={2}
              justifyContent="flex-start"
              gap={3}
              mt={2}
            >
              <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
                Thêm dòng
              </SoftButton>
            </SoftBox>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
